import { render, staticRenderFns } from "./CaixaEspecies.vue?vue&type=template&id=208f3046&scoped=true"
import script from "./CaixaEspecies.vue?vue&type=script&lang=js"
export * from "./CaixaEspecies.vue?vue&type=script&lang=js"
import style0 from "./CaixaEspecies.vue?vue&type=style&index=0&id=208f3046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f3046",
  null
  
)

export default component.exports